import { render } from "./MediumPriorityAlerts.vue?vue&type=template&id=6145366e"
import script from "./MediumPriorityAlerts.vue?vue&type=script&lang=js"
export * from "./MediumPriorityAlerts.vue?vue&type=script&lang=js"

import "./MediumPriorityAlerts.vue?vue&type=style&index=0&id=6145366e&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__